// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__vFze9","paywall":"styles_paywall__VAlSi","circle":"styles_circle__S8eKz","paywallText":"styles_paywallText__yZhno","paywalled":"styles_paywalled__uNDW6"};